<div class="footer-wrapper">
  <div class="footer-disclaimer">
    <div>
      This service is owned and operated by {{ brand.companyName }} on behalf of {{ businessName }}. For support, go to
      <a rel="noopener" target="_blank" [href]="brand.contactUrl">{{ brand.contactUrl }}</a>
    </div>
  </div>
  <div class="footer-contact-info">
    <div class="footer-company-line">
      <span>{{ brand.companyName }}</span>

      <app-version />
    </div>
    @for (line of brand.companyAddressLines; track line) {
      <span>{{ line }}</span>
    }
  </div>
</div>
